<template>
  <project-one-toolbar-tab-layout id="project-one-toolbar-sizing" :title="bp('toolbarSizingInfo')">
    <form @submit.prevent="submitSizeSelections">
      <div v-if="optionsCreated">
        <form-group
          v-for="item in sizeData"
          :key="item.id"
          v-model="choice[item.id]"
          :label="item.description"
          type="select"
          :disabled="isP1ConfigInCart"
          :name="item.description"
          :multi-items="options[item.id]"
          :qaid="`p1-size-${item.description}`"
          @change="updateSize($event, item.id, item.topTierPackageId)"
        />
      </div>
      <trek-button
        primary
        :disabled="isLoading || !isEditable || isP1ConfigInCart"
        type="button"
        qaid="p1-sizing-save-btn"
        @click="submitSizeSelections"
      >
        <span v-html="bp('save')" />
      </trek-button>
    </form>
  </project-one-toolbar-tab-layout>
</template>

<script>
import ProjectOneToolbarTabLayout from '@/projectOne/components/toolbar/components/ProjectOneToolbarTabLayout.vue';
import FormGroup from '@/components/FormGroup';
import TrekButton from '@/components/TrekButton';
import {mapState, mapMutations, mapActions} from 'vuex';
import editableStatus from '@/projectOne/mixins/editableStatus';

export default {
  name: 'ProjectOneToolbarSizing',
  components: {
    ProjectOneToolbarTabLayout,
    FormGroup,
    TrekButton,
  },
  mixins: [editableStatus],
  data() {
    return {
      isLoading: false,
      options: {},
      optionsCreated: false,
      choice: {},
      updatedChoices: [],
      selected: null,
    };
  },
  computed: {
    ...mapState('projectOne', ['bikeData', 'customerSizeSelections', 'selections', 'sizeData', 'isP1ConfigInCart']),
  },
  created() {
    this.setUseToastInterceptor(false); // disable success toast from POST on initial drawer opening, only want visible when submitting changes

    this.fetchModule({
      buildId: this.$route.params.buildId,
      module: 'sizing',
    })
      .then(() => this.setOptions())
      .finally(() => this.setUseToastInterceptor(true));
  },
  methods: {
    ...mapMutations('projectOne', ['setIsSaveModalVisible', 'setOnSaveCallbackFunction']),
    ...mapMutations('global', ['setUseToastInterceptor']),
    ...mapActions('projectOne', ['fetchModule', 'updateSelection']),

    setOptions() {
      this.selections.forEach((item) => {
        // Set default value in each dropdown based on selections return
        this.choice[item.groupId] = item.choiceId;
      });

      this.sizeData.forEach((item) => {
        // Specify options for each group id (like 6 for frame size)
        this.options[item.id] = [];

        item.choices.forEach((choice) => {
          this.options[item.id].push({
            value: choice.id,
            displayName: choice.description,
          });
        });
      });

      this.optionsCreated = true;
    },

    updateSize(event, groupId, topTierPackageId) {
      this.selected = event.target.value;
      let choiceIdNumber = Number(this.selected);
      let updatedIndex = this.updatedChoices.findIndex((choice) => choice.groupId === groupId);

      if (updatedIndex > -1) {
        // Found an index for the existing groupId, need to update the corresponding choiceId
        this.updatedChoices[updatedIndex].choiceId = choiceIdNumber;
        this.updatedChoices[updatedIndex].topTierPackageId = topTierPackageId;
      } else {
        // If it's NOT index -1, then it doesn't exist yet, and should push whole new object
        this.updatedChoices.push({
          groupId: groupId,
          choiceId: choiceIdNumber,
          topTierPackageId: topTierPackageId,
        });
      }
    },

    submitSizeSelections() {
      this.isLoading = true;

      if (this.bikeData?.code && this.bikeData?.description) {
        this.handleSubmission();
      } else {
        this.setOnSaveCallbackFunction(this.handleSubmission);
        this.setIsSaveModalVisible(true);
        this.isLoading = false;
      }
    },

    handleSubmission() {
      setTimeout(() => {
        this.updateSelection({
          buildId: this.$route.params.buildId,
          module: 'sizing', // Manually pass 'sizing' as module endpoint; currentRoute in Vuex picks up module from P1 customizer in bg of drawer
          selections: this.updatedChoices,
        });
      }, 500);

      this.isLoading = false;
    },
  },
};
</script>
